module.exports = __webpack_public_path__ + "img/job-alt.a87d0ba4.png";